import {  IMicrositeRecipientForList } from '@nkr/models/index';
import { ICellRendererParams } from 'ag-grid-community';
import { Icon } from 'react-icons-kit';
import { check } from 'react-icons-kit/fa/check'
import { close } from 'react-icons-kit/fa/close'
import { comments } from 'react-icons-kit/fa/comments';
import { timer } from 'react-icons-kit/iconic/timer';
import { rocket } from 'react-icons-kit/fa/rocket';
import { pause } from 'react-icons-kit/fa/pause';

const CommStatusRenderer = (props: ICellRendererParams) => {
    const data = props.data as IMicrositeRecipientForList;

    const msgMap = [
        {id: 0, color: 'green', icon: rocket, title: 'Start the conversation!'},
        {id: 30, color: '#53A7F5', icon: timer, title: 'Awaiting response from recipient...'},
        {id: 40, color: 'pink', icon: comments, title: 'Recipient replied to your message...'},
        {id: 43, color: 'black', icon: check, title: 'No Action Required'},
        {id: 45, color: 'black', icon: close, title: 'Patient Not Interested In Coaching'},
        {id: 50, color: '#53A7F5', icon: pause, title: 'Microsite deactivated.'}
    ];
    
    const msg = msgMap.find(f => f.id == data.commStatus);
    
    return (
        <div>
            <span style={{ color: msg.color }} title={msg.title}>
                <Icon icon={msg.icon} style={{color: msg.color}}/>
            </span>
        </div>
    );
}

export default CommStatusRenderer;